import { createAsyncThunk } from '@reduxjs/toolkit';
import { CURR_USER_BOOTSTRAP } from './constants';
import {
  currentUserQueryKey,
  fetchCurrentUserProfile,
} from '@/api/useCurrentUser';

// Resolved through the TanStack cache rather than calling `http` directly, so
// app boot and any `useCurrentUser()` consumer share one GET /me instead of
// issuing one each. The reducers below are untouched — this still returns the
// same envelope, and `selectCurrUser` remains the read path for the rest of the
// app.
const getCurrUser = async (_args, { extra: { queryClient } }) => {
  try {
    return await queryClient.fetchQuery({
      queryKey: currentUserQueryKey,
      queryFn: fetchCurrentUserProfile,
    });
  } catch {
    return undefined;
  }
};

const getCurrUserPermission = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/me/permission');
  } catch {
    return undefined;
  }
};

const getSettingsDetails = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/settings');
  } catch {
    return undefined;
  }
};

const onFetchCurrUser = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/me');
  } catch {
    return undefined;
  }
};

const getExtensionInstallStatus = async () => {
  return true;
};

const onFetchImport = async (_args, { extra: { http } }) => {
  try {
    return await http.get('/user_import_statuses/recent_pending_import');
  } catch {
    return undefined;
  }
};

const onFetchImportById = async ({ importId }, { extra: { http } }) => {
  try {
    return await http.get(`/user_import_statuses/${importId}`);
  } catch {
    return undefined;
  }
};

export const bootstrapCurrentUserPermissions = createAsyncThunk(
  CURR_USER_BOOTSTRAP,
  getCurrUser
);

export const bootstrapCurrentUser = createAsyncThunk(
  CURR_USER_BOOTSTRAP,
  getCurrUser
);

export const bootstrapCurrentPermission = createAsyncThunk(
  'user/permission',
  getCurrUserPermission
);

export const bootstrapSettingsDetails = createAsyncThunk(
  'user/settings',
  getSettingsDetails
);

export const fetchCurrentUser = createAsyncThunk(
  'current/user/fetch',
  onFetchCurrUser
);

export const bootstrapExtensionCheck = createAsyncThunk(
  'user/extension',
  getExtensionInstallStatus
);

export const fetchPendingImport = createAsyncThunk(
  'current/import/fetch',
  onFetchImport
);

export const fetchImportById = createAsyncThunk(
  'current/import/fetch/id',
  onFetchImportById
);
